var map = {
	"./action.svg": 1108,
	"./adventure.svg": 8206,
	"./car.svg": 1664,
	"./casual.svg": 9037,
	"./defense.svg": 774,
	"./fps.svg": 1675,
	"./game.svg": 7460,
	"./home.svg": 3467,
	"./new.svg": 5560,
	"./other.svg": 3004,
	"./puzzle.svg": 9854,
	"./pvp.svg": 5740,
	"./skill.svg": 9605,
	"./strategy.svg": 533,
	"./tag.svg": 1130,
	"./time.svg": 8309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6978;